<template>
  <div id="Disaster_apply">
    <div class="font">
      <span class="introSubTitle"><b>地质灾害遥感监测预警系统</b></span>
      <p class="textStyle">
        基于空天遥感与地面传感网实时监测结果，研制了遥感地质灾害监测预警系统，具备地质灾害（滑坡、泥石流等）信息提取、灾情上报、灾害损毁评估、灾害预案与案例管理等功能， 在新源县开展了地质灾害遥感监测与应急服务应用示范，将空天地遥感应急监测用于地质灾害应急，提升地方灾害应急能力。
      </p>
    </div>
 <!-- <br/>   -->
<!--    <img width="100%" src="@/assets/img/scientific/Disaster-1.jpg" />-->
<!--    <p class="img_figure">地质灾害应急一张图</p>-->
    <img width="100%" src="@/assets/img/scientific/Disaster-2.jpg" />
    <p class="img_figure">地面在线监测预警系统</p>
<!--    <img width="100%" src="@/assets/img/scientific/Disaster-3.jpg" />-->
<!--    <p class="img_figure">滑坡堰塞湖二维拼接</p>-->
    <img width="100%" src="@/assets/img/scientific/Disaster-4.jpg" />
    <p class="img_figure">滑坡堰塞湖三维模型</p>
    <img width="100%" src="@/assets/img/scientific/Disaster-7.jpg" />
    <p class="img_figure">灾后损失评估</p>
  </div>
</template>

<script>
// img

export default {
  data() {
    return {};
  },
};
</script>

<style lang="less">
#Disaster_apply {
  margin-top: 20px;
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #454545;
  }
}
</style>
